import { memo, useState } from 'react';

import { Loader, LoaderSizeXL, LoaderVariants } from '@picsart/design-system/components/Loader';

import { LoaderService } from 'components/GlobalLoader';
import useMount from 'hooks/useMount';

const GlobalLoader = () => {
  const [isOpen, setIsOpen] = useState(false);

  useMount(() => {
    LoaderService.subscribe(val => setIsOpen(val));
  });

  return isOpen ? (
    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 11 }}>
      <Loader variant={LoaderVariants.Local} size={LoaderSizeXL} isWithoutBackground />
    </div>
  ) : null;
};

export default memo(GlobalLoader);
